import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy3",
  "use": "copy3-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"copy3\">\n<rect x=\"9\" y=\"8\" width=\"9\" height=\"11\" rx=\"1\" stroke=\"#9E9E9E\" stroke-width=\"2\" stroke-linejoin=\"round\" />\n<path d=\"M13 5H8C6.89543 5 6 5.89543 6 7V14\" stroke=\"#9E9E9E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol